import { style, styleVariants } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const { checkbox } = semanticThemeTokens;

export const wrapper = style({
  display: "flex",
  alignItems: "center",
  position: "relative",
  columnGap: primitiveTokens.sizing["2x"]
});

export const checkboxRootVariants = styleVariants({
  ghost: {
    opacity: 0.4
  },
  primary: {
    opacity: 1
  }
});

export const checkboxRoot = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 20,
  height: 20,
  borderRadius: primitiveTokens.sizing["1x"],
  borderWidth: primitiveTokens.strokes.md,
  borderStyle: "solid",
  transition: primitiveTokens.animations.elementFade,
  borderColor: checkbox.unchecked.default.borderColor,
  backgroundColor: checkbox.unchecked.backgroundColor,
  cursor: "pointer",

  selectors: {
    // Unchecked: focus-visible state
    '&[data-state="unchecked"]:focus-visible': {
      backgroundColor: checkbox.unchecked.backgroundColor,
      borderColor: checkbox.unchecked.focus.borderColor,
      boxShadow: primitiveTokens.colors.shadow.focusRing,
      outline: "none"
    },

    // Unchecked: hover state (not disabled)
    '&[data-state="unchecked"]:not([data-disabled]):hover': {
      backgroundColor: checkbox.unchecked.backgroundColor,
      borderColor: checkbox.unchecked.hover.borderColor
    },

    // Unchecked: active state (not disabled)
    '&[data-state="unchecked"]:not([data-disabled]):active': {
      backgroundColor: checkbox.unchecked.active.backgroundColor,
      borderColor: checkbox.unchecked.active.borderColor,
      boxShadow: "none"
    },

    // Unchecked: disabled state
    '&[data-state="unchecked"][data-disabled]': {
      backgroundColor: checkbox.unchecked.disabled.backgroundColor,
      borderColor: checkbox.unchecked.disabled.borderColor,
      cursor: "default"
    },

    // Checked: default state
    '&[data-state="checked"]': {
      backgroundColor: checkbox.checked.backgroundColor,
      borderColor: "transparent"
    },

    // Checked: focus state (mouse click)
    '&[data-state="checked"]:focus': {
      backgroundColor: checkbox.checked.active.backgroundColor,
      borderColor: checkbox.checked.focus.borderColor,
      outline: "none",
      boxShadow: "none"
    },

    // Checked: focus-visible state (keyboard)
    '&[data-state="checked"]:focus-visible': {
      backgroundColor: checkbox.checked.backgroundColor,
      borderColor: checkbox.checked.focus.borderColor,
      boxShadow: primitiveTokens.colors.shadow.focusRing,
      outline: "none"
    },

    // Checked: hover state (not disabled)
    '&[data-state="checked"]:not([data-disabled]):hover': {
      borderColor: checkbox.checked.hover.borderColor
    },

    // Checked: active state (not disabled)
    '&[data-state="checked"]:not([data-disabled]):active': {
      backgroundColor: checkbox.checked.active.backgroundColor,
      borderColor: checkbox.checked.active.borderColor,
      boxShadow: "none",
      outline: "none"
    },

    // Checked: disabled state
    '&[data-state="checked"][data-disabled]': {
      backgroundColor: checkbox.checked.disabled.backgroundColor,
      borderColor: checkbox.checked.disabled.borderColor
    }
  }
});

// Label text next to checkbox
export const labelText = style({
  cursor: "pointer",
  color: checkbox.labelTextColor,
  fontSize: primitiveTokens.type.sm,
  fontWeight: "500",
  userSelect: "none",
  selectors: {
    [`${wrapper}[data-disabled="true"] &`]: {
      cursor: "default",
      color: checkbox.unchecked.disabled.labelTextColor
    }
  }
});

export const checkboxIndicator = style({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: 20,
  height: 20,
  pointerEvents: "none",
  color: checkbox.checked.checkmarkColor,
  backgroundColor: "none",
  selectors: {
    [`${checkboxRoot}[data-state="checked"] &`]: {
      transform: "scale(1)",
      opacity: 1
    },
    [`${checkboxRoot}[data-state="checked"][data-disabled] &`]: {
      fill: checkbox.checked.disabled.checkmarkColor,
      color: checkbox.checked.disabled.checkmarkColor
    }
  }
});
